import { useRef, useEffect } from 'react';

export default function useRightClick(handler) {
  const targetElement = useRef();

  let rightClickCapture;
  useEffect(() => {
    rightClickCapture = (event) => {
      if (targetElement.current && !targetElement.current.contains(event.target)) {
        handler();
      }
      else { }
    };
    document.addEventListener('contextmenu', rightClickCapture);
    return () => {
      document.removeEventListener('contextmenu', rightClickCapture);
    };
  }, []);

  return [targetElement];

}